import { Stack, Typography } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import type { SideListing } from '../../types';
import {
  generateBedBathString,
  generateFullPropertyInfoString,
} from './helpers';

export const PropertyInfo = ({
  bathrooms,
  bedrooms,
  price,
}: Pick<SideListing, 'bathrooms' | 'bedrooms' | 'price'>) => {
  const isMobile = useIsMobile('md');
  if (isMobile) {
    if (price) {
      const bedBathString = generateBedBathString({ bedrooms, bathrooms });

      return (
        <Stack direction="column">
          <Typography variant="body3">
            {price.toLocaleString('en', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </Typography>
          {bedBathString && (
            <Typography variant="body3">{bedBathString}</Typography>
          )}
        </Stack>
      );
    }

    return (
      <Stack direction="column">
        {bedrooms ? (
          <Typography variant="body3">{`${bedrooms} bed`}</Typography>
        ) : null}
        {bathrooms ? (
          <Typography variant="body3">{`${bathrooms} bath`}</Typography>
        ) : null}
      </Stack>
    );
  }

  const propertyInfoString = generateFullPropertyInfoString({
    bathrooms,
    bedrooms,
    price,
  });
  return <Typography variant="body3">{propertyInfoString}</Typography>;
};
